/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import { useMemo } from 'react';
import { Trans, t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import useStyles from './MatrixHeaderStyles';
import Sorter, { ASCENDING, DESCENDING, NONE } from './Sorter';
import { useSetTableSorters, useTableSorters } from '../data-table/TableState';

const nameTitle = i18n._(t`Sort by Name`);
const statusTitle = i18n._(t`Sort by Status`);

function getSortDirection(sorter, sortField) {
    if (!sorter || sorter.property !== sortField) {
        return NONE;
    }

    return sorter.direction;
}

function Header(props) {
    const classes = useStyles();
    const { column, alignRight, sorterIndex } = props;

    const sorters = useTableSorters();
    const setSorters = useSetTableSorters();

    const sorter = useMemo(() => sorters?.[sorterIndex], [sorterIndex, sorters]);
    const nameSort = getSortDirection(sorter, column.nameSortField);
    const statusSort = getSortDirection(sorter, column.statusSortField);

    function handleNameSortClick() {
        const sort = nameSort === ASCENDING ? DESCENDING : ASCENDING;

        setSorters(
            sorters.map((aSorter, index) => {
                if (index === sorterIndex) {
                    return {
                        property: column.nameSortField,
                        direction: sort,
                    };
                }

                return aSorter;
            })
        );
    }

    function handleStatusSortClick() {
        const sort = statusSort === ASCENDING ? DESCENDING : ASCENDING;

        setSorters(
            sorters.map((aSorter, index) => {
                if (index === sorterIndex) {
                    return {
                        property: column.statusSortField,
                        direction: sort,
                    };
                }

                return aSorter;
            })
        );
    }

    return (
        <div className={classes.headerContainer}>
            <div className="headerTitleContainer">{i18n._(column.title)}</div>
            <div className="headerSortContainer">
                <div className="headerSpacer" />
                <div
                    className={alignRight ? 'headerSort headerRight' : 'headerSort headerLeft'}
                    title={nameTitle}
                    id="sortName"
                    onClick={handleNameSortClick}
                >
                    <Trans>Name</Trans>
                    <Sorter sort={nameSort} />
                </div>
                <div
                    className={alignRight ? 'headerSort headerRight' : 'headerSort headerLeft'}
                    title={statusTitle}
                    id="sortStatus"
                    onClick={handleStatusSortClick}
                >
                    <Trans>Status</Trans>
                    <Sorter sort={statusSort} />
                </div>
            </div>
        </div>
    );
}

export function headerRenderer(column, alignRight, sorterIndex) {
    return <Header column={column} alignRight={alignRight} sorterIndex={sorterIndex} />;
}
